import { createContext } from "react";
import type { GroupActionsContextType } from "../GroupsProvider.types";

const GroupActionsContext = createContext<GroupActionsContextType | undefined>(undefined);
GroupActionsContext.displayName = "GroupActionsContext";

export default GroupActionsContext;
